
/**
 * Scrolls the element to the bottom.
 */
export const scrollToBottom = (element: Element | null) => {
    if (element) {
        element.scrollTop = element.scrollHeight;
    }
};

/**
 * Checks if the element is scrolled near the bottom (within threshold).
 */
export const isNearBottom = (element: Element | null, threshold: number = 100): boolean => {
    if (!element) return false;
    const { scrollTop, scrollHeight, clientHeight } = element;
    return scrollTop >= scrollHeight - clientHeight - threshold;
};

/**
 * Auto-scroll to bottom with a slight delay to ensure content is rendered.
 * Only scrolls if the user is already near the bottom or force is true.
 */
export const attemptAutoScroll = (
    container: Element | null,
    force: boolean = false,
    threshold: number = 100
) => {
    if (!container) return;

    const shouldScroll = force || isNearBottom(container, threshold);

    if (shouldScroll) {
        setTimeout(() => {
            scrollToBottom(container);
        }, 100);
    }
};
